import { render } from "./ai-dictionary-grid-ro.vue?vue&type=template&id=bed85820"
import script from "./ai-dictionary-grid-ro.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-dictionary-grid-ro.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/dictionary-components/ai-dictionary-grid-ro.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bed85820"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bed85820', __exports__)) {
    api.reload('bed85820', __exports__)
  }
  
  module.hot.accept("./ai-dictionary-grid-ro.vue?vue&type=template&id=bed85820", () => {
    api.rerender('bed85820', render)
  })

}


export default __exports__